// @vendors
const Immutable = require('immutable');
// @constants
const actionTypes = require('constants/actionTypes');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes');
// @utilities
import { createConfig } from 'utilities/flagBasedFeatures';

// To be constant of what is uses in the application, can be usefull init this state
// with posibles flags.

function setInitialState() {
    return Immutable.fromJS({
        isFetching: false,
        hasBeenFetched: false,
        hasError: false,
        error: '',
        'direct-money-enabled': false,
        chores: false,
        budget: false,
        'loan-retail-enabled': false,
        'sec-kits': false,
        'sec-sessions': false,
        'account-revolving': false,
        'upload-img-domiciliacion-enabled': false,
        'hire-card-at-home-abroad-enabled': false,
        'hire-card-revolving-enabled': false,
        'hire-pack-openyoung-enabled': false,
        'hire-card-virtual-credit-enabled': false,
        'collective-diamond-pack-enabled': false,
        'broker-transfer-pension-plans': false,
        'home-insurance-enabled': false,
        'mortgage-home-insurance-enabled': false,
        'agregador-accounts-enabled': false,
        'agregador-cards-enabled': false,
        'agregador-deposits-enabled': false,
        'agregador-loans-enabled': false,
        'agregador-investments-enabled': false,
        'virtual-debit-card-hiring-enabled': false,
        'wealth-spinoff': false,
        'wealth-cm-traspass-enabled': true,
        'immediate-transfers-enabled': false,
        'web-inactive-account-enabled': false,
        'databank-enabled': false,
        'notification-management': false,
        'add-documentation-openyoung-enabled': false,
        'status-documentation-openyoung-enabled': false,
        'broker-cambios-comercializadora': false,
        'watchlist-enabled': false,
        'tutor-database-enabled': false,
        'profile-shipping-address-add-enabled': false,
        'profile-shipping-address-edit-enabled': false,
        'profile-shipping-address-remove-enabled': false,
        'card-cancel-pay-later-enabled': false,
        'card-cancel-deferred-purchase-enabled': false,
        'web-basic-account-consents-off-enabled': false,
        'hire-accounts-add-documentation-enabled': false,
        'hire-accounts-pin-required-enabled': false,
        not_allowed_hire_accounts_add_documentation_countries: false,
        not_allowed_hire_passport_pin_countries: false,
        wealth_funds_show_prospectus_document_national_funds: true,
        wealth_funds_show_purchase_prospectus_document: true,
        wealth_funds_show_prospectus_document_international_funds: true,
        wealth_funds_show_precontractual_document_national_funds: true,
        wealth_funds_show_risk_assumption_document: true,
        wealth_funds_show_recommendation_report_document: true,
        wealth_funds_show_fund_presentation_document: true,
        wealth_product_name_from_catalogue: true,
        fund_glossary:
            window.druppalSettings && window.druppalSettings.fund_glossary
                ? window.druppalSettings.fund_glossary
                : false,
    });
}

const flagBasedFeatures = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.FLAG_BASED_FEATURES_REQUEST:
            return state.mergeDeep({
                isFetching: true,
                successfully: false,
                hasError: false,
                error: '',
            });
        case actionTypes.FLAG_BASED_FEATURES_SET_ORIGIN_COUNTRY:
            const originCountry = action.originCountry
                ? action.originCountry.toUpperCase()
                : COUNTRY_CODE_ES;
            return state.mergeDeep(
                {
                    originCountry: originCountry,
                },
                createConfig(state.toJS(), originCountry),
            );
        case actionTypes.FLAG_BASED_FEATURES_SUCCESS:
            return state.mergeDeep(
                {
                    isFetching: false,
                    hasBeenFetched: true,
                    error: '',
                },
                createConfig(action.payload.flags, state.get('originCountry')),
            );
        case actionTypes.FLAG_BASED_FEATURES_ERROR:
            return state.mergeDeep({
                isFetching: false,
                hasError: true,
                error: action.payload.error,
            });
        default:
            return state;
    }
};

module.exports = flagBasedFeatures;
